module.exports = __webpack_public_path__ + "static/media/sarvesh.27c3a65f.png";